module.exports = __webpack_public_path__ + "img/aboutpic.d4b8beb2.jpeg";